<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>

  <div class="page-header">
    <div class="header-content">
      <div class="header-text">
        <h1 class="page-title">
          <i class="fa fa-tasks title-icon"></i>
          {{ 'parametros.tipoAndamento.titulo' | translate }}
        </h1>
        <p class="page-subtitle">{{ 'parametros.tipoAndamento.descricao' | translate }}</p>
      </div>
      <button type="button" class="btn-floating-add" (click)="showDialog()"
              pTooltip="{{ 'parametros.tipoAndamento.adicionarTipoAndamento' | translate }}"
              tooltipPosition="left">
        <i class="fa fa-plus"></i>
        <span class="btn-label">{{ 'parametros.tipoAndamento.adicionarTipoAndamento' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="tipo-eventos-grid" *ngIf="!carregando && tipoAndamentos.length > 0">
    <div class="tipo-evento-card"
         *ngFor="let tipoAndamento of tipoAndamentos; let i = index"
         [style.animation-delay]="(i * 0.1) + 's'">
      <div class="card-header-modern">
        <div class="tipo-evento-icon">
            <i class="fa fa-tasks text-white"></i>
        </div>
        <div class="tipo-evento-info">
          <h3 class="tipo-evento-name">{{ tipoAndamento.nome }}</h3>
          <div class="tipo-evento-stats">
            <span class="stat-item">
              <i class="fa fa-link mr-1"></i>
              {{ tipoAndamento.vinculos }} {{ 'parametros.tipoAndamento.vinculos' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div class="card-actions">
        <button type="button"
                class="btn-action btn-primary-action"
                (click)="verVinculos(tipoAndamento)"
                pTooltip="{{ 'parametros.tipoAndamento.verVinculos' | translate }}"
                tooltipPosition="top">
          <i class="fa fa-link"></i>
          <span>{{ 'parametros.tipoAndamento.gerenciar' | translate }}</span>
        </button>

        <button type="button"
                class="btn-action btn-danger-action"
                (click)="removerTipoAndamento(tipoAndamento.id)"
                pTooltip="{{ 'parametros.tipoAndamento.remover' | translate }}"
                tooltipPosition="top">
          <i class="fa fa-trash"></i>
          {{ 'parametros.tipoAndamento.excluir' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!carregando && tipoAndamentos.length === 0">
    <div class="empty-state-content">
      <div class="empty-state-icon">
        <i class="fa fa-tasks"></i>
      </div>
      <h3 class="empty-state-title">{{ 'parametros.tipoAndamento.nenhumTipoAndamento' | translate }}</h3>
      <p class="empty-state-description">{{ 'parametros.tipoAndamento.descricaoVazio' | translate }}</p>
      <button type="button" class="btn-empty-state" (click)="showDialog()">
        <i class="fa fa-plus mr-2"></i>
        {{ 'parametros.tipoAndamento.criarPrimeiroTipoAndamento' | translate }}
      </button>
    </div>
  </div>
</div>

<p-dialog [(visible)]="display" [modal]="true" [style]="{width: '40rem'}" [closable]="true" [draggable]="false"
          [styleClass]="'modern-dialog'">
  <ng-template pTemplate="header">
    <div class="modal-header-modern">
      <div class="modal-icon">
        <i class="fa fa-plus"></i>
      </div>
      <div class="modal-title-content">
        <h5 class="modal-title">
          {{ 'parametros.tipoAndamento.adicionarTipoAndamento' | translate }}
        </h5>
        <p class="modal-subtitle">{{ 'parametros.tipoAndamento.descricaoModal' | translate }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <form #formTipoAndamento="ngForm" (ngSubmit)="adicionarTipoAndamento(nomeNovoTipoAndamento)" class="modern-form">
      <div class="form-group-modern">
        <label for="nomeTipoAndamento" class="form-label-modern">
          <i class="fa fa-tasks label-icon"></i>
          {{ 'parametros.tipoAndamento.nomeTipoAndamento' | translate }} *
        </label>
        <div class="input-container">
          <input type="text"
                 class="form-input-modern"
                 id="nomeTipoAndamento"
                 name="nomeTipoAndamento"
                 [(ngModel)]="nomeNovoTipoAndamento"
                 required
                 maxlength="20"
                 placeholder="{{ 'parametros.tipoAndamento.placeholderNome' | translate }}"
                 autocomplete="off">
          <div class="input-border"></div>
        </div>
        <div class="error-message" *ngIf="formTipoAndamento.submitted && !nomeNovoTipoAndamento">
          <i class="fa fa-exclamation-circle"></i>
          {{ 'parametros.tipoAndamento.nomeObrigatorio' | translate }}
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="modal-footer-modern">
      <button type="button" class="btn-modal btn-cancel" (click)="hideDialog()">
        <i class="fa fa-times"></i>
        {{ 'parametros.tipoAndamento.cancelar' | translate }}
      </button>
      <button type="button" class="btn-modal btn-save" (click)="adicionarTipoAndamento(nomeNovoTipoAndamento)">
        <i class="fa fa-save"></i>
        {{ 'parametros.tipoAndamento.salvar' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="displayConfirmarExclusao" [modal]="true" [style]="{width: '35rem'}" [closable]="true" [draggable]="false"
          [styleClass]="'modern-dialog'">
  <ng-template pTemplate="header">
    <div class="modal-header-modern">
      <div class="modal-icon modal-icon-danger">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <div class="modal-title-content">
        <h5 class="modal-title">
          {{ 'parametros.tipoAndamento.confirmarRemocao' | translate }}
        </h5>
        <p class="modal-subtitle">{{ 'parametros.tipoAndamento.confirmarRemocaoTexto' | translate }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <div class="confirmation-content-simple">
      <div class="confirmation-text">
        <p class="confirmation-message">
          {{ 'parametros.tipoAndamento.confirmarRemocaoMensagem' | translate }}
        </p>
        <div class="tipo-evento-name-highlight">
          <i class="fa fa-tasks"></i>
          <strong>{{ tipoAndamentoParaExcluir?.nome }}</strong>
        </div>
        <p class="confirmation-warning">
          {{ 'parametros.tipoAndamento.confirmarRemocaoDetalhes' | translate }}
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="modal-footer-modern">
      <button type="button" class="btn-modal btn-cancel" (click)="hideDialogConfirmarExclusao()">
        <i class="fa fa-times"></i>
        {{ 'parametros.tipoAndamento.cancelar' | translate }}
      </button>
      <button type="button" class="btn-modal btn-danger" (click)="confirmarExclusao()">
        <i class="fa fa-trash"></i>
        {{ 'parametros.tipoAndamento.confirmar' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="displayVinculos" [modal]="true" [style]="{width: '80rem'}" [closable]="true" [draggable]="false"
          [styleClass]="'modern-dialog modal-vinculos'">
  <ng-template pTemplate="header">
    <div class="modal-header-modern">
      <div class="modal-icon modal-icon-primary">
        <i class="fa fa-link"></i>
      </div>
      <div class="modal-title-content">
        <h5 class="modal-title">
          {{ 'parametros.tipoAndamento.gerenciarVinculos' | translate }}
        </h5>
        <p class="modal-subtitle">
          <i class="fa fa-tasks mr-2"></i>
          {{ tipoAndamentoSelecionado?.nome }}
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <div *ngIf="carregandoVinculos" class="loading-container">
      <div class="loading-content">
        <div class="loading-spinner">
          <div class="spinner-modern"></div>
        </div>
        <div class="loading-text">
          <h4>{{ 'parametros.tipoAndamento.carregandoVinculos' | translate }}</h4>
          <p>{{ 'parametros.tipoAndamento.aguarde' | translate }}</p>
        </div>
      </div>
    </div>

    <div *ngIf="!carregandoVinculos" class="modal-content-container">
      <div class="modal-column">
        <div class="modal-card">
          <div class="modal-card-header">
            <div class="card-header-content">
              <div class="card-title-section">
                <div class="card-icon">
                  <i class="fa fa-list"></i>
                </div>
                <div class="card-title-text">
                  <h6 class="card-title">{{ 'parametros.tipoAndamento.elementosDisponiveis' | translate }}</h6>
                  <span class="card-count">{{ elementosDisponiveisFiltrados.length }}</span>
                </div>
              </div>
              <button type="button"
                      class="btn-modern btn-modern-success"
                      (click)="vincularTodosFiltrados()"
                      [disabled]="elementosDisponiveisFiltrados.length === 0"
                      pTooltip="{{ 'parametros.tipoAndamento.vincularTodos' | translate }}"
                      tooltipPosition="top">
                <i class="fa fa-plus"></i>
                <span>{{ 'parametros.tipoAndamento.vincularTodos' | translate }}</span>
              </button>
            </div>
          </div>
          <div class="search-container">
            <div class="search-input-group">
              <div class="search-icon">
                <i class="fa fa-search"></i>
              </div>
              <input type="text"
                     class="search-input"
                     [(ngModel)]="termoPesquisaDisponiveis"
                     (input)="filtrarElementosDisponiveis()"
                     placeholder="{{ 'parametros.tipoAndamento.pesquisarElementos' | translate }}"
                     autocomplete="off">
              <button class="search-clear"
                      *ngIf="termoPesquisaDisponiveis"
                      type="button"
                      (click)="limparPesquisaDisponiveis()">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="modal-card-body">
            <div class="elements-list">
              <div class="element-item"
                   *ngFor="let elemento of elementosDisponiveisFiltrados; trackBy: trackByElemento"
                   (click)="adicionarVinculo(elemento)"
                   [class.disabled]="elemento.vinculado">
                <div class="element-content">
                  <div class="element-icon">
                    <i class="fa fa-cube"></i>
                  </div>
                  <div class="element-info">
                    <span class="element-name">{{ elemento.nome }}</span>
                    <div class="tipo-evento-fabrica" *ngIf="elemento.contemFabrica">
                      <i class="fa fa-industry tipo-evento-fabrica-icon"></i>
                      <span class="tipo-evento-fabrica-text">Contém ID fábrica</span>
                    </div>
                    <span class="element-created-by" *ngIf="elemento.criadoPor">
                      {{ elemento.criadoPor }}
                    </span>
                  </div>
                  <div class="element-action">
                    <i class="fa fa-plus" *ngIf="!elemento.vinculado"></i>
                    <i class="fa fa-check" *ngIf="elemento.vinculado"></i>
                  </div>
                </div>
              </div>
              <div class="empty-state-list" *ngIf="elementosDisponiveisFiltrados.length === 0">
                <div class="empty-icon">
                  <i class="fa fa-search"></i>
                </div>
                <p class="empty-text">{{ 'parametros.tipoAndamento.nenhumElementoEncontrado' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-column">
        <div class="modal-card">
          <div class="modal-card-header">
            <div class="card-header-content">
              <div class="card-title-section">
                <div class="card-icon card-icon-linked">
                  <i class="fa fa-link"></i>
                </div>
                <div class="card-title-text">
                  <h6 class="card-title">{{ 'parametros.tipoAndamento.elementosVinculados' | translate }}</h6>
                  <span class="card-count card-count-linked">{{ elementosVinculados.length }}</span>
                </div>
              </div>
              <button type="button"
                      class="btn-modern btn-modern-danger"
                      (click)="removerTodosVinculos()"
                      [disabled]="elementosVinculados.length === 0"
                      pTooltip="{{ 'parametros.tipoAndamento.removerTodos' | translate }}"
                      tooltipPosition="top">
                <i class="fa fa-times"></i>
                <span>{{ 'parametros.tipoAndamento.removerTodos' | translate }}</span>
              </button>
            </div>
          </div>
          <div class="search-container">
            <div class="search-input-group">
              <div class="search-icon">
                <i class="fa fa-search"></i>
              </div>
              <input type="text"
                     class="search-input"
                     [(ngModel)]="termoPesquisaVinculados"
                     (input)="filtrarElementosVinculados()"
                     placeholder="{{ 'parametros.tipoAndamento.pesquisarElementos' | translate }}"
                     autocomplete="off">
              <button class="search-clear"
                      *ngIf="termoPesquisaVinculados"
                      type="button"
                      (click)="limparPesquisaVinculados()">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="modal-card-body">
            <div class="elements-list">
              <div class="element-item element-item-linked"
                   *ngFor="let elemento of elementosVinculadosFiltrados; trackBy: trackByElemento"
                   (click)="removerVinculo(elemento)">
                <div class="element-content">
                  <div class="element-icon element-icon-linked">
                    <i class="fa fa-link"></i>
                  </div>
                  <div class="element-info">
                    <span class="element-name">{{ elemento.nome }}</span>
                    <div class="tipo-evento-fabrica" *ngIf="elemento.contemFabrica">
                      <i class="fa fa-industry tipo-evento-fabrica-icon"></i>
                      <span class="tipo-evento-fabrica-text">Contém ID fábrica</span>
                    </div>
                    <span class="element-created-by" *ngIf="elemento.criadoPor">
                      {{ elemento.criadoPor }}
                    </span>
                  </div>
                  <div class="element-action element-action-remove">
                    <i class="fa fa-times"></i>
                  </div>
                </div>
              </div>
              <div class="empty-state-list" *ngIf="elementosVinculados.length === 0">
                <div class="empty-icon">
                  <i class="fa fa-info-circle"></i>
                </div>
                <p class="empty-text">{{ 'parametros.tipoAndamento.nenhumVinculo' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="modal-footer-modern">
      <button type="button" class="btn-modal btn-cancel" (click)="hideDialogVinculos()">
        <i class="fa fa-times"></i>
        {{ 'parametros.tipoAndamento.fechar' | translate }}
      </button>
      <button type="button" class="btn-modal btn-save" (click)="salvarVinculos()" [disabled]="!alteracoesVinculos">
        <i class="fa fa-save"></i>
        {{ 'parametros.tipoAndamento.salvarAlteracoes' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
